var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasterCardWithBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31.6,
    height: 20,
    rx: 2,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5986 18C25.0169 18 28.5986 14.4183 28.5986 10C28.5986 5.58172 25.0169 2 20.5986 2C16.1804 2 12.5986 5.58172 12.5986 10C12.5986 14.4183 16.1804 18 20.5986 18Z",
    fill: "#FFA914"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 10C12.6 9.7604 12.6107 9.5232 12.6314 9.2889H18.9668C18.9238 8.8008 18.8368 8.3256 18.7102 7.8666H12.8878C13.0245 7.3715 13.2082 6.8961 13.4327 6.4444H18.1664C17.9143 5.9373 17.61 5.4611 17.2603 5.0222H14.3373C14.7623 4.4883 15.254 4.01 15.8 3.5999C14.4629 2.5955 12.8011 2 11 2C6.5817 2 3 5.5817 3 10C3 14.4184 6.5817 18 11 18C12.8011 18 14.4629 17.4045 15.8 16.4001C15.2541 15.99 14.7623 15.5117 14.3373 14.9777H17.2603C17.6099 14.5388 17.9142 14.0627 18.1664 13.5554H13.4327C13.2082 13.1037 13.0245 12.6283 12.8878 12.1332H18.7102C18.837 11.6742 18.9239 11.199 18.9668 10.7108H12.6314C12.6107 10.4768 12.6 10.2396 12.6 10Z",
    fill: "#EF4136"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCardWithBackground);
export default __webpack_public_path__ + "static/media/master-card-with-background.054b263b0d829e6afbbdf8d0a02f9dff.svg";
export { ForwardRef as ReactComponent };